export const apiPath = '/v2/integration_job_settings';
const actionType = 'INTEGRATION_JOB_SETTINGS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
